import { ToastContainer as ToastifyContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ToastContainer() {
    return <ToastifyContainer position="bottom-right" />;
}

export function showSuccessToast() {
    toast.success("Success");
}

export function showErrorToast() {
    toast.error("Something went wrong. Try again later.");
}